<template>
  <el-card class="box-card" shadow="always">
    <div slot="header" class="clearfix user-header">
      <span><i class="el-icon-user-solid"></i> {{$t('user.userInfo.user')}}</span>
      <span style="color: #409EFF">{{$t('user.userInfo.info')}}</span>
    </div>
      <p>
        {{$t('user.userInfo.form.username')}}: {{user.row.username}}
      </p>
      <p>
        {{$t('user.userInfo.form.email')}}: {{user.row.email}}
      </p>
      <p>
        {{$t('user.userInfo.form.role')}}: {{getRole(user.row.role)}}
      </p>
      <p>
        {{$t('user.userInfo.form.group')}}: {{user.row.group}}
      </p>
  </el-card>
</template>

<script>
  export default {
    name: 'UserInfoSimple',
    props: {
      user: {
        type: Object
      }
    },
    data() {
      return {
        roles: this.$t('user.roles'),
      };
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
    },
  };
</script>

<style>
  .user-header {
    display: flex;
    justify-content: space-between;
  }
</style>
